import Modal from './Modal';
import { H2 } from '../H2/H2';
import { RadioButtonCard } from '../RadioButton/RadioButtonCard';
import { PrimaryButton, WhiteButton } from '../Button/Buttons';
import { AssessmentType } from '../../../types/AISystems.types';

type ModalSwitchAssessmentProps = {
  assessmentType: AssessmentType;
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  selectedOption: CardOption | null;
  setSelectedOption: (option: CardOption | null) => void;
  onClick: () => void;
};

type CardOption = {
  label: string;
  description: string;
  contextTransfer: boolean;
};

const radioButtonCardOptions: CardOption[] = [
  {
    label: 'Carry Over Context (Recommended)',
    description:
      'Use your previous questionnaire responses as context for the AI-powered assessment and continue the classification process automatically.',
    contextTransfer: true
  },
  {
    label: 'Start from Scratch',
    description:
      'Begin a completely new assessment session without using previous questionnaire responses.',
    contextTransfer: false
  }
];

const ModalSwitchAssessment = ({
  assessmentType,
  showModal,
  setShowModal,
  selectedOption,
  setSelectedOption,
  onClick
}: ModalSwitchAssessmentProps) => {
  const h2Title =
    assessmentType === 'QUESTIONNAIRE'
      ? 'Switch To AI-Powered Assessment'
      : 'Switch to Questionnaire Assessment?';

  const paragraphText =
    assessmentType === 'QUESTIONNAIRE'
      ? 'You are transitioning to our AI-driven risk assessment for a faster, guided experience. How would you like to proceed?'
      : 'You are transitioning to the step-by-step manual questionnaire. Because unstructured responses cannot be carried over to predefined form selections, your current AI assessment progress will be discarded and you will start from scratch. Are you sure you want to proceed? ';

  const displayRadioOptions = assessmentType === 'QUESTIONNAIRE';

  const modalWidth =
    assessmentType === 'QUESTIONNAIRE' ? 'w-[820px]' : 'w-[512px]';

  const disableButton = assessmentType === 'QUESTIONNAIRE' && !selectedOption;

  return (
    <Modal open={showModal} dialogPanelClassnames={modalWidth}>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <H2 title={h2Title} textSize="text-lg leading-6" />
          <p className="text-sm text-gray-500">{paragraphText}</p>
        </div>
        {displayRadioOptions && (
          <div className="flex gap-6 h-[134px]">
            {radioButtonCardOptions.map((option) => (
              <RadioButtonCard
                key={option.label}
                label={option.label}
                desctiption={option.description}
                onChange={() => {
                  setSelectedOption(option);
                }}
                selected={selectedOption?.label === option.label}
              />
            ))}
          </div>
        )}
        <div className="flex flex-row-reverse gap-4">
          <PrimaryButton disabled={disableButton} onClick={onClick}>
            Confirm & Switch
          </PrimaryButton>
          <WhiteButton
            onClick={() => {
              setShowModal(false);
              setSelectedOption(null);
            }}
          >
            Cancel
          </WhiteButton>
        </div>
      </div>
    </Modal>
  );
};

export default ModalSwitchAssessment;
